import { render, staticRenderFns } from "./ProcessChemicalInfo.vue?vue&type=template&id=6395a39a&scoped=true"
import script from "./ProcessChemicalInfo.vue?vue&type=script&lang=js"
export * from "./ProcessChemicalInfo.vue?vue&type=script&lang=js"
import style0 from "./ProcessChemicalInfo.vue?vue&type=style&index=0&id=6395a39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395a39a",
  null
  
)

export default component.exports